import captchaApi from "@classin/captcha-api";

export const CHINA_PHONE = '0086'

// 环境区分mode
export const ENV_TYPE = {
  "www13.eeo.im": captchaApi.EEO_CAP_MODE.dev,
  "www14.eeo.im": captchaApi.EEO_CAP_MODE.dev,
  "www.eeo.im": captchaApi.EEO_CAP_MODE.dev,
  "www.eeo.cn": captchaApi.EEO_CAP_MODE.prod,
};